import { render, staticRenderFns } from "./InstagramProfileDetails.vue?vue&type=template&id=a259b6f4&scoped=true&"
import script from "./InstagramProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./InstagramProfileDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramProfileDetails.vue?vue&type=style&index=0&id=a259b6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a259b6f4",
  null
  
)

export default component.exports